import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const DEFAULT_LOGO = "/demkan-logo.png";

export function useLogo(company) {
  const [src, setSrc] = useState(DEFAULT_LOGO);
  const path = company?.logo_path, version = company?.logo_version;
  useEffect(() => {
    if (!path) { setSrc(DEFAULT_LOGO); return undefined; }
    let url = "";
    api.get("/settings/logo", { responseType: "blob", params: { v: version } })
      .then(r => { url = URL.createObjectURL(r.data); setSrc(url); }).catch(() => setSrc(DEFAULT_LOGO));
    return () => { if (url) URL.revokeObjectURL(url); };
  }, [path, version]);
  return src;
}
